import { Link } from "react-router-dom";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="bg-[#0A0A0A] text-white/70 border-t border-white/10"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            <div className="flex items-center">
                <img
                    src="/images/stabilor-logo.png"
                    alt="Stabilor"
                    width="180"
                    height="60"
                    loading="lazy"
                    className="h-12 w-auto"
                />
            </div>
            <div className="text-sm text-center font-mono-label">
                © {new Date().getFullYear()} Stabilor · Minden jog fenntartva
            </div>
            <div className="flex md:justify-end gap-6 text-sm">
                <Link
                    to="/aszf"
                    data-testid="footer-aszf"
                    className="hover:text-white transition-colors"
                >
                    ÁSZF
                </Link>
                <Link
                    to="/adatvedelem"
                    data-testid="footer-adatvedelem"
                    className="hover:text-white transition-colors"
                >
                    Adatvédelem
                </Link>
            </div>
        </div>
    </footer>
);
